export default function getDocumentPortalLink(hash) {
  const isNewPortalEnabled = process.env.REACT_APP_ENABLE_NEW_DOC_PORTAL === "true";

  const baseUrl = isNewPortalEnabled
    ? `${process.env.REACT_APP_DOCUMENT_UPLOAD_PORTAL_URL}/contracts`
    : `${window.location.origin}/certfocus/certUpload`;

  return `${baseUrl}/${hash}`;
}